import type { ApiError } from "../api/client";

type TFn = (key: string, fallback: string) => string;

/**
 * Shape check before an auth call (something@something, no spaces), so "admin" or a
 * half-typed address gets a Serbian hint instead of the server's 400. The backend's
 * @Email stays the real rule.
 */
export function looksLikeEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+$/.test(value);
}

/**
 * Text for a pre-login screen failure the screen does not map by code. Never the
 * server's `message`: it is English and technical ("Request body failed validation"),
 * and a network failure is a TypeError ("Failed to fetch"), not an ApiError at all.
 */
export function authFallbackError(err: unknown, t: TFn, fallback?: string): string {
  // The rate-limit filter and the per-account reset limit both answer 429, with different bodies.
  if ((err as Partial<ApiError> | null)?.status === 429) {
    return t("errors.rateLimited", "Previše pokušaja. Sačekajte malo pa pokušajte ponovo.");
  }
  return fallback ?? t("errors.generic", "Nešto je pošlo po zlu. Pokušajte ponovo.");
}
